import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { FullScreenSvg } from './svgs';

export const IconFullScreen: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={FullScreenSvg} viewBox="0 0 24 24" {...props} />;
};
